import styled from "styled-components";
import { ClientSettingsDropdownListItemDefaultBox } from "./dropdown-list-item.default.box";
import { grayColors } from "../../../../../../../themes/architecture/gray-colors";
import { hexToRgba } from "../../../../../../../themes/hex-to-rgba";

export const ClientSettingsDropdownSelectedMrGreenBox = styled(ClientSettingsDropdownListItemDefaultBox)`
    color: ${({ isSelected, theme }) => isSelected ? theme.colors.textActive : grayColors.gray203};

    &:hover {
        color: ${({ isSelected, theme }) => isSelected ? theme.colors.textActive : grayColors.gray233};
    }

    &:not(:last-of-type)::after {
        background: ${hexToRgba(grayColors.gray233, 0.2)};
        box-shadow: unset;
    }
`